var map = {
	"./text1-s.png": "3352",
	"./text1.png": "b994",
	"./text2-s.png": "a39d",
	"./text2.png": "1b3f",
	"./text3-s.png": "2f7f",
	"./text3.png": "36da",
	"./text4-s.png": "59b9",
	"./text4.png": "013e",
	"./textImg.png": "946f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce64";